/* eslint-disable @typescript-eslint/no-explicit-any, jsdoc/require-returns, jsdoc/require-param */
/**
 * Delays the execution of the decorated method until the specified duration has passed since the last time it was invoked.
 * @param duration - Duration of the wait time in milliseconds.
 * @param keyFn - (Optional) A function that generates a dynamic key based on method arguments to identify distinct invocations.
 */
export const Debounce = (duration, keyFn) => {
    return (_target, key, descriptor) => {
        const originalMethod = descriptor.value;
        if (keyFn && keyFn.length > originalMethod.length) {
            console.error(`Debounce decorator keyFn argument list must match the decorated function (${key}). `);
        }
        descriptor.value = function (...args) {
            var _a;
            this.__debounce = (_a = this.__debounce) !== null && _a !== void 0 ? _a : {};
            const debounceKey = keyFn ? `${key}.${keyFn(...args)}` : key;
            clearTimeout(this.__debounce[debounceKey]);
            this.__debounce[debounceKey] = setTimeout(() => {
                originalMethod.call(this, ...args);
            }, duration);
        };
    };
};
